import { render, staticRenderFns } from "./AdminReportNewRepeatOrders.vue?vue&type=template&id=0f78a7f4"
import script from "./AdminReportNewRepeatOrders.vue?vue&type=script&lang=js"
export * from "./AdminReportNewRepeatOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f78a7f4')) {
      api.createRecord('0f78a7f4', component.options)
    } else {
      api.reload('0f78a7f4', component.options)
    }
    module.hot.accept("./AdminReportNewRepeatOrders.vue?vue&type=template&id=0f78a7f4", function () {
      api.rerender('0f78a7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportNewRepeatOrders.vue"
export default component.exports